import Vue from 'vue'

const STORAGE_KEY = 'WORKFLOW_FRONT_APP_API_TOKEN'

export default {
  install(Vue, options) {
    const token = this.__getToken()
    if (token)
      this.bind(token)

    Vue.prototype.$auth = Vue.auth = this
  },

  bind(token) {
    this.__setToken(token)
    this.__storeToken(token)
  },

  unbind() {
    window.localStorage.removeItem(STORAGE_KEY)
    this.__deleteToken()
  },

  isLoggedIn() {
    return this.__getToken()
  },

  __setToken(token) {
    Vue.http.setHeader('Authorization', `token ${token}`)
  },

  __deleteToken() {
    Vue.http.removeHeader('Authorization')
  },

  __storeToken(token) {
    window.localStorage.setItem(STORAGE_KEY, token)
  },

  __getToken() {
    if (window.localStorage.getItem(STORAGE_KEY) === null) return false
    else return window.localStorage.getItem(STORAGE_KEY)
  }
}
